// extracted by mini-css-extract-plugin
export default {"fileStorage":"FileStorage_fileStorage__tXate"};